import { v2UsersLoginSocialOpenpassCreate } from '@on3/api';
import { SocialIcon } from '@on3/ui-lib/components/SocialIcon';
import { externalApi, useAuth } from '@on3/ui-lib/index';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

declare global {
  interface Window {
    openpass: any;
  }
}

const loadOpenPass = () =>
  new Promise((res, rej) => {
    const script = document.createElement('script');

    script.src =
      'https://cdn.myopenpass.com/openpass-js-sdk/v4/openpass-js-sdk.min.js';
    script.async = true;

    script.onload = () => res(true);
    script.onerror = () => rej(new Error('OpenPass API script failed to load'));

    document.body.appendChild(script);
  });

const signInUser = async (idToken: string) => {
  const user = await v2UsersLoginSocialOpenpassCreate(externalApi, {
    idToken,
    registerIfNew: true,
  });

  return user;
};

export const OpenPassButton = () => {
  const { setUserToken } = useAuth();

  const params = useSearchParams();
  const returnTo = params.get('returnTo') || '/';

  const router = useRouter();

  const [opClient, setOpClient] = useState<any>(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    loadOpenPass().then(() => {
      if (window.openpass) {
        setScriptLoaded(true);

        const client = new window.openpass.OpenPassClient({
          clientId: process.env.NEXT_PUBLIC_OPENPASS_CLIENT_ID || '',
        });

        setOpClient(client);
      }
    });
  }, []);

  const handleOpenPassAuth = useCallback(async () => {
    if (scriptLoaded && opClient) {
      try {
        const res = await opClient.signInWithPopup();
        const user = await signInUser(res.rawIdToken);

        setUserToken(user);
        router.push(returnTo);
      } catch (err) {
        console.error('OpenPass login error:', err);
      }
    }
  }, [scriptLoaded, opClient, setUserToken, router, returnTo]);

  return null; // NOTE: temporary disable OpenPass login button

  return (
    <button disabled={!opClient} onClick={handleOpenPassAuth} type="button">
      <SocialIcon type="openpass" />
      <span className="sr-only">Sign in with OpenPass</span>
    </button>
  );
};
